export var isFipsRegion = function (region) {
    return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/isFipsRegion.js
// module id = 334
// module chunks = 0